import React, { CSSProperties, MouseEventHandler } from 'react';

import { ChildrenPropType } from 'src/utils/types';

type Props = {
  href: string;
  children: ChildrenPropType;

  className?: string;
  style?: CSSProperties;
  dataTest?: string;
  dataTestId?: string;
  download?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  title?: string;
};

/**
 * a component for outer links (not for inner app links)
 */
export const UiOuterLink: React.FC<Props> = ({
  className,
  href,
  children,
  style,
  dataTest,
  dataTestId,
  download,
  onClick,
  title,
}: Props) => (
  <a
    className={className}
    rel="noopener nofollow noreferrer"
    target="_blank"
    href={href}
    style={style}
    data-test={dataTest}
    download={download}
    data-testid={dataTestId}
    onClick={onClick}
    title={title}
  >
    {children}
  </a>
);
